<template>
  <v-row   justify="center" class="messageBackground gasses pt-10 pb-8">

    <div class="gas ar">
      <h2 class="title">DELIVERY & TAKEAWAY</h2>
      <p class="message">Entregas a domicilio y retiros en nuestro local</p>
    </div>
    <div class="gas he">
      <h2 class="title">PEDIDOS PROGRAMADOS</h2>
      <p class="message"> Hace tu pedido anticipado y retira sin esperar!</p>
    </div>

    <div class="gas kr">
      <h2 class="title">BAR DE EMPANADAS</h2>
      <p class="message"> Venite a comer y tomar a nuestro nuevo local!</p>
    </div>



  </v-row>
</template>

<script>
export default {
  name: "HomeParallax",
  computed: {
    getWidth(){
      if(this.$vuetify.breakpoint.xsOnly){
        return '90%'
      }
      if(this.$vuetify.breakpoint.smOnly){
        return '80%'
      }
      if(this.$vuetify.breakpoint.xlOnly){
        return '30%'
      }
      return '40%'
    }
  }
}
</script>

<style scoped>

.messageBackground{
  background: linear-gradient(0deg, rgba(0, 0, 0, 1), rgb(26, 25, 25), rgba(18, 18, 18, 1))
}

.gasses {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.gas {
  --blur: 1.75rem;
  --box-blur: calc(0.5 * var(--blur));
  --glow: var(--color);

  align-items: center;
  border-radius: 12px;
  border: 4px solid currentColor;
  box-shadow:
    /* --- "glass" tube --- */
    /* inside */ inset 0 0 0 2px rgba(0, 0, 0, 0.15),
    /* outside */      0 0 0 2px rgba(0, 0, 0, 0.15),
    /* --- glow --- */
    /* inside */ inset 0 0 var(--box-blur) var(--glow),
    /* outside */      0 0 var(--box-blur) var(--glow);
  color: var(--color, white);
  display: inline-flex;
  flex-direction: column;
  font-family: system-ui, sans-serif;
  height: 7rem;
  min-width: 320px;
  justify-content: space-around;
  padding: 1rem;
  margin-right: 1rem;
  margin-bottom: 1rem;

  .title {
    font-size: 2rem;
    padding-bottom: 0.3rem;
    text-shadow: 0 0 var(--blur) var(--glow);
  }

  .message {
    font-size: 1rem;
    text-shadow: 0 0 var(--blur) var(--glow);
    margin-bottom: 0;
  }

  &.he { --color: #FCEAAC; filter: saturate(175%); }
  &.ne { --color: #FDA802; filter: brightness(110%); }
  &.ar { --color: #E555C7; filter: brightness(125%); }
  &.kr { --color: #B7E7F7; filter: saturate(200%); }
  &.xe { --color: #C4C4C6; filter: brightness(105%); }
}
</style>
